<script>
  import { onMount, setContext, afterUpdate, beforeUpdate } from 'svelte';
  import * as L from 'leaflet';

  export let geojson;
  export let centroid;

  let container;
  let map;
  let dataLayer;

  onMount(() => {
    /*
    [43.052, 86.212]
    nyc - [40.735707, -73.990963]
    center us- [40.23480648685492, -99.14089442776677]
    */

    map = L.map(container, {
      zoomControl: false,
      dragging: false,
      keyboard: false,
      scrollWheelZoom: false,
      tap: false,
      dragging: false,
      doubleClickZoom: false,
      boxZoom: false
    }).setView([40.23480648685492, -99.14089442776677], 5);

    /*
      ESRI World Imagery https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}
      CartoDB https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png
      OpenTopo https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png
      local /public/osm-tiles/{z}/{x}/{y}.png
    */
    L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      {
        attribution:
          'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        maxZoom: 18
      }
    ).addTo(map);

    return () => {
      map.remove();
    };
  });

  function clearMap() {
    // console.log(`clearMap - infosatview`);
    if (dataLayer) {
      removeFeatures();
      removeDataLayer();
      dataLayer = null;
      highlightBounds = null;
    }
  }

  afterUpdate(() => {
    // console.log('afterUpdate - infosatview');
    updateMap();
  });

  function removeFeatures() {
    dataLayer.eachLayer((l) => {
      l.removeFrom(map);
    });
    dataLayer.clearLayers();
  }

  function removeDataLayer() {
    dataLayer.remove();
  }

  function addBoundaries() {
    const c = L.circle([centroid.coordinates[1], centroid.coordinates[0]], {
      radius: 0,
      stroke: false
    });
    return c;
  }

  function updateDataLayer(radiusScale) {
    hiddenLayer.eachLayer((l) => {
      if (!l.properties[factorKey] && l.properties[factorKey] !== 0) {
        l.setRadius(0);
      } else {
        l.setRadius(radiusScale(l.properties[factorKey]));
      }

      if (isActive(l.properties.facilityid)) {
        l.removeFrom(hiddenLayer);
        l.addTo(dataLayer);
      }
    });

    dataLayer.eachLayer((l) => {
      if (!l.properties[factorKey] && l.properties[factorKey] !== 0) {
        // console.log(
        //   l.properties.name,
        //   l.properties.facilityid,
        //   factorKey,
        //   l.properties[factorKey],
        //   radiusScale(l.properties[factorKey])
        // );
        l.setRadius(0);
      } else {
        l.setRadius(radiusScale(l.properties[factorKey]));
      }

      if (!isActive(l.properties.facilityid)) {
        l.removeFrom(dataLayer);
        l.addTo(hiddenLayer);
      }
    });

    return dataLayer;
  }

  function createDataLayer(radiusScale) {
    return L.featureGroup(
      geojson.features.map((f) => {
        const c = L.circle(
          [
            f.properties.centroid.coordinates[1],
            f.properties.centroid.coordinates[0]
          ],
          {
            radius: f.properties[factorKey]
              ? radiusScale(f.properties[factorKey])
              : radiusScale(0),
            stroke: true,
            weight: 1,
            fillOpacity: 0.65
          }
        );
        facilityLeafletMap[f.properties.facilityid] = c._leaflet_id;
        leafletFacilityMap[c._leaftlet_id] = f.properties.facilityid;
        c.on('click', () => {
          // console.log(
          //   `${f.properties.name} - ${factorKey}: ${f.properties[factorKey]}`
          // );
          setFacility(f.properties.facilityid);
        });
        c.properties = f.properties;
        return c;
      })
    );
  }

  function updateMap(rebound = true) {
    // console.log('updateMap - infosatview');
    // console.log(factorKey);
    // console.log(geojson.features[10]);

    dataLayer = addBoundaries();

    if (!map.hasLayer(dataLayer)) {
      dataLayer.addTo(map);
    }

    map.fitBounds(dataLayer.getBounds(), { maxZoom: 16, animate: true });
  }
</script>

<div bind:this={container} class="info-sat-view">
  {#if map}
    <slot />
  {/if}
</div>

<style>
  div {
    width: 100%;
    height: 30vh;
    min-height: 200px;
    max-height: 400px;
  }
</style>
